import React from 'react';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import withStyles from '@material-ui/core/styles/withStyles';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import getFullness from '../../calendar/bookingStatHelper';

const styles = {
  available: {
    fontSize: '11px',
    border: '2px solid green',
    margin: '2px',
  },
  full: {
    fontSize: '11px',
    border: '2px solid #d16d6d',
    color: '#969696',
    margin: '2px',
  },
  fullIcon: {
    color: '#969696',
  },
  tooltipTitle: {
    whiteSpace: 'pre-line',
  },
};

const ScheduleChipField = withStyles(styles)(({ classes, record }) => {
  const formattedDate = record.start_time.replace(' 00:00:00', '');
  const fullness = getFullness(record);
  const isAvailable = fullness <= 90;

  const icon = isAvailable ? (
    <DoneIcon />
  ) : (
    <CloseIcon className={classes.fullIcon} />
  );

  const tooltipText = `${fullness}% Full\n\nCurrent Scheduled Works: ${record.current_scheduled_works}\nScheduled Work Limit: ${record.limit_scheduled_works}\nCurrent Total Hours: ${record.current_total_hours}\nTotal Hour Limit: ${record.limit_total_hours}`;
  return (
    <Tooltip title={<div className={classes.tooltipTitle}>{tooltipText}</div>}>
      <Chip
        key={formattedDate}
        label={formattedDate}
        className={isAvailable ? classes.available : classes.full}
        icon={icon}
      />
    </Tooltip>
  );
});

export default ScheduleChipField;
